var map = {
	"./FooterLogo.svg": 529,
	"./Gati.svg": 359,
	"./Group.svg": 115,
	"./Icon-Check.svg": 640,
	"./Maru.svg": 96,
	"./arrow.svg": 719,
	"./black_logo.svg": 933,
	"./bsm.svg": 653,
	"./culture.svg": 433,
	"./culture2.svg": 236,
	"./culture3.svg": 169,
	"./github.svg": 405,
	"./github2.svg": 75,
	"./insta.svg": 304,
	"./white_logo.svg": 45
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;